import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { ShippingFeesInterface } from 'common/types/entities/ShippingFeesInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export const createShippingFees = (
  parentId: string,
  masterBlockId?: MasterBlockId,
): ShippingFeesInterface => {
  return {
    ...generateBaseEntity(EntityTypeEnum.ShippingFees, parentId, masterBlockId),
    fontSize: 16,
    padding: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  }
}
